import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'div[data-component-type=navigation]',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('positionAnimation', [
      state('displayLogo', style({ top: 0 })),
      state('displayNavigations', style({ top: '-230px' })),
      transition('displayLogo <=> displayNavigations', group([
        query('@*', animateChild()),
        animate('500ms 100ms ease'),
      ]))
    ]),
    trigger('logoAnimation', [
      state('displayLogo', style({ opacity: 1 })),
      state('displayNavigations', style({ opacity: 0 })),
      transition('displayLogo => displayNavigations', animate('250ms ease')),
      transition('displayNavigations => displayLogo', animate('250ms 350ms ease'))
    ]),
    trigger('navigationsAnimation', [
      state('displayLogo', style({ opacity: 0 })),
      state('displayNavigations', style({ opacity: 1 })),
      transition('displayLogo => displayNavigations', animate('1250ms ease')),
      transition('displayNavigations => displayLogo', animate('300ms ease'))
    ])
  ]
})
export class NavigationComponent implements OnInit {

  
  @Input() navigations$!: Observable<Navigation[]>
  @Input() animationState$!: Observable<'displayNavigations' | 'displayLogo'>

  constructor() { }

  ngOnInit(): void {
  }

  trackByUrl(index: number, item: Navigation) {
    return item.url
  }

}

export interface Navigation {
  name: string,
  url: string,
  valid: boolean,
  after: boolean,
  current: boolean,
  presence: boolean
}
